import WebsocketService from '@/utils/websocket';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  ws: new WebsocketService({
    url: import.meta.env.VITE_STOCK_SOCKET_URL,
  }),
  connected: false,
};

export const websocketSlice = createSlice({
  name: 'websocket',
  initialState,
  reducers: {
    connect: (state) => {
      if (!state.connected) {
        state.ws.connect();
        state.connected = true;
      }
    },
  },
});

export const { connect } = websocketSlice.actions;

export const selectWebsocket = (state) => state.websocket.ws;

export default websocketSlice.reducer;
